import { useState } from "react";

export function useTheme() {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));
  const toggle = () => {
    const next = !dark;
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("n365-theme", next ? "dark" : "light");
    setDark(next);
  };
  return { dark, toggle };
}
